<template>
  <div>
    <BigTitle :bigtitle="bigtitle"></BigTitle>
    <div class="userIndicators">
      <div class="indicator" v-for="(item,index) in userList" :key="index">
        <img class="bg" src="@/assets/images/index/indicators_icon.png"/>
        <div>
          <p class="counts">{{item.counts}}</p>
          <p class="text">{{item.text}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BigTitle from '../bigTitle';

export default {
  data () {
    return {
      options: {},
    };
  },
  components: {
    BigTitle
  },
  props: {
    bigtitle:{
      type: Object,
      default: () => ({})
    },
    userList: {
      type: Array,
      default: () => ({})
    },
  },
  watch: {
    
  },
  created () {
  }
}
</script>
<style lang="scss" scoped>

.bg{
  width:84px;
  height:60px;
}
.userIndicators{
  width:700px;
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: 50% 50%;
  margin-bottom:30px;
}
.indicator{
  display: flex;
  margin-top:20px;
  // margin-bottom:30px;
  .counts{
    font-size: 30px;
    color: #3DDDFF;
  }
  .text{
    font-size: 18px;
    color: #FFFFFF;
  }
}
</style>